import { CapIQ, PublicComp } from 'pages/ValuationsAllocation/types';
import { FlattenedData, GPCAttributes } from './types';

/**
 * Flattens CapIQ data and formats numeric values with decimal places based on field attributes.
 * @param data - The CapIQ data object to flatten
 * @param attributes - The field attributes containing decimal place configuration
 * @returns A flattened object with formatted numeric values according to their attribute specifications
 */
const makeCapIQDataFlatWithDecimalPlaces = ({ data, attributes }: { data: PublicComp; attributes: GPCAttributes }) =>
  Object.keys(data).reduce<FlattenedData>((flattenedObj: any, key: string) => {
    const { value } = data[key as keyof PublicComp] as CapIQ;
    const attribute = attributes[key as keyof GPCAttributes];
    // eslint-disable-next-line no-param-reassign
    flattenedObj[key] =
      typeof value === 'number' && attribute
        ? Number(value.toString()).toFixed(Number(attribute.decimal_places))
        : value;
    return flattenedObj;
  }, {});

export default makeCapIQDataFlatWithDecimalPlaces;
